"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
var cookies_1 = require("@zapier/cookies");
var isProduction_1 = __importDefault(require("./isProduction"));
exports.getCookie = function (id) {
    if (!isProduction_1.default()) {
        // Consider switching to `readCookie` from `@zapier/cookies`.
        // eslint-disable-next-line no-console
        console.warn('@zapier/common-utils `getCookie` is deprecated.');
    }
    try {
        return cookies_1.readCookie(id);
    }
    catch (e) {
        return undefined;
    }
};
exports.default = exports.getCookie;
